import { createAction } from '@reduxjs/toolkit'

import { WebSocketEvents } from 'constants/WebSockets'
import { accountNotificationsListener } from 'utils/services/notificationsService'

import { AbilitiesData } from '../models/Ability/schemas'

export const abilitiesUpdated = createAction<AbilitiesData>('@abilities/update')

interface AbilitiesUpdatedEvent {
  actor: number
  client_id: number | null
  event: WebSocketEvents.ABILITIES_UPDATED
  model: {
    abilities: AbilitiesData
  }
}

accountNotificationsListener.on(
  WebSocketEvents.ABILITIES_UPDATED,
  (data: AbilitiesUpdatedEvent, dispatch) => {
    const { abilities } = data.model

    dispatch(abilitiesUpdated(abilities))
  },
)
